import { render, staticRenderFns } from "./votacao.vue?vue&type=template&id=6df22a62&scoped=true&"
import script from "./votacao.vue?vue&type=script&lang=js&"
export * from "./votacao.vue?vue&type=script&lang=js&"
import style0 from "./votacao.vue?vue&type=style&index=0&id=6df22a62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df22a62",
  null
  
)

export default component.exports